var map = {
	"./icon1.svg": 6146,
	"./icon2.svg": 3389,
	"./icon3.svg": 3005,
	"./icon4.svg": 9746,
	"./icon5.svg": 9584,
	"./icon6.svg": 7282,
	"./icon7.svg": 5862,
	"./icon8.svg": 2838,
	"./icon9.svg": 5906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8978;